
import { concat, replace, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { item, equalsWith, append, tryFind as tryFind_1, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { unwrap, ofNullable, map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { reduce, iterate, toArray, contains, filter, map as map_2, length, splitAt, isEmpty, sort, choose, tryFind, singleton, forAll, empty, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { defaultOf, stringHash, createObj, comparePrimitives, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ActiveTableFilter, TableMsg$1 } from "./Types.js";
import { toLocalTime, equals as equals_1, toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import { min } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Double.js";
import { toArray as toArray_1, empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { tryParseDateRangeFilterValues, setQueryParams } from "./State.js";
import { defaultOf as defaultOf_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import Filter_Text from "../../../public/assets/icons/Filter_Text.svg";
import { DropdownButton, TextButton } from "../../Components/Button.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import Cog from "../../../public/assets/icons/Cog.svg";
import { FSharpMap__get_Item } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { inventoryTypeLabel } from "../../Components/InventoryTypeBadge.js";

function downloadCsv(csvContent, filename, onDownloaded) {
    const csv = join("\r\n", map((row) => join(";", map((cell) => {
        const escaped = replace(cell, "\"", "\"\"");
        if ((((escaped.indexOf(";") >= 0) ? true : (escaped.indexOf("\"") >= 0)) ? true : (escaped.indexOf("\r") >= 0)) ? true : (escaped.indexOf("\n") >= 0)) {
            return ("\"" + escaped) + "\"";
        }
        else {
            return escaped;
        }
    }, row)), csvContent));
    const options = {
        endings: "transparent",
        type: "text/csv;charset=utf-8;",
    };
    const blob = new Blob(["﻿", csv], options);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    onDownloaded();
}

function columnFilterValues(columnDefinition, value) {
    const matchValue = columnDefinition.Filter;
    switch (matchValue) {
        case "locationSelect": {
            const values = defaultArg(map_1(ofArray, ofNullable(value)), empty());
            if (forAll((filterValue_2) => (filterValue_2 === "__exact_location__"), values)) {
                return empty();
            }
            else {
                return values;
            }
        }
        case "select":
        case "categorySelect":
        case "dateRange":
            return defaultArg(map_1(ofArray, ofNullable(value)), empty());
        default: {
            const matchValue_1 = ofNullable(value);
            let matchResult, filterValue_1;
            if (matchValue_1 != null) {
                if (matchValue_1 !== "") {
                    matchResult = 0;
                    filterValue_1 = matchValue_1;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return singleton(filterValue_1);
                default:
                    return empty();
            }
        }
    }
}

function defaultColumnFilter(state, columnId) {
    return tryFind((columnFilter) => (columnFilter.id === columnId), defaultArg(state.DefaultColumnFilters, empty()));
}

export function activeColumnFilters(state) {
    return choose((columnDefinition) => {
        const currentValues = defaultArg(map_1((columnFilter_1) => columnFilterValues(columnDefinition, columnFilter_1.value), tryFind_1((columnFilter) => (columnFilter.id === columnDefinition.Id), state.ColumnFilters)), empty());
        const defaultValues = defaultArg(map_1((columnFilter_2) => columnFilterValues(columnDefinition, columnFilter_2.value), defaultColumnFilter(state, columnDefinition.Id)), empty());
        if (equals(sort(currentValues, {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }), sort(defaultValues, {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        }))) {
            return undefined;
        }
        else {
            return [columnDefinition, currentValues];
        }
    }, ofArray(state.ColumnDefinitions));
}

export function hasActiveFilters(state, pageFilters) {
    if ((state.GlobalSearchPattern !== "") ? true : !isEmpty(activeColumnFilters(state))) {
        return true;
    }
    else {
        return !isEmpty(pageFilters);
    }
}

function restoreDefaultColumnFilter(state, dispatch, columnId) {
    let matchValue;
    const otherColumnFilters = state.ColumnFilters.filter((columnFilter) => (columnFilter.id !== columnId));
    dispatch(new TableMsg$1(6, [(matchValue = defaultColumnFilter(state, columnId), (matchValue == null) ? otherColumnFilters : append(otherColumnFilters, [matchValue]))]));
}

function formatDate(date) {
    return toString(date, "dd.MM.yyyy");
}

function ActiveFilterChip(props) {
    let elems_2, arg_1, elems_1, elems;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["data-test-id", concat("active-filter-chip-", ...props.Filter.FilterId)], ["className", join(" ", ["inline-flex", "items-center", "gap-1", "h-8", "pl-3", "pr-0.5", "rounded-full", "border", "border-primary", "bg-white", "text-sm", "max-w-full"])], (elems_2 = [reactElement("span", {
        className: join(" ", ["whitespace-nowrap"]),
        children: concat(props.Filter.Label, ...": "),
    }), reactElement("span", {
        className: join(" ", ["font-semibold", "truncate"]),
        children: props.Filter.Value,
    }), reactElement("button", createObj(ofArray([["type", "button"], ["data-test-id", concat("active-filter-chip-", props.Filter.FilterId, ..."-remove")], ["aria-label", (arg_1 = {
        name: props.Filter.Label,
    }, patternInput[1].t("table.active_filters.remove", arg_1))], ["className", join(" ", ["flex", "items-center", "justify-center", "h-7", "w-7", "rounded-full", "cursor-pointer", "hover:bg-background"])], ["onClick", (_arg) => {
        props.Filter.OnRemove();
    }], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-3", "w-3"])], (elems = [Delete_1()], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function ActiveFilterBar(props) {
    let elems_3;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const joinValues = (values) => {
        const patternInput_1 = splitAt(min(3, length(values)), values);
        const hiddenValues = patternInput_1[1];
        return join(" ", toList(delay(() => append_1(singleton_1(join(", ", patternInput_1[0])), delay(() => {
            let arg_1;
            return !isEmpty(hiddenValues) ? singleton_1((arg_1 = {
                number: length(hiddenValues),
            }, patternInput[1].t("table.active_filters.more_values", arg_1))) : empty_1();
        })))));
    };
    const displayValue = (value) => {
        if (value === "__empty__") {
            return t("table.filter_empty_option");
        }
        else {
            return value;
        }
    };
    const activeFilters = toList(delay(() => append_1((props.State.GlobalSearchPattern !== "") ? singleton_1(new ActiveTableFilter("global-search", t("general.search"), props.State.GlobalSearchPattern, () => {
        if (props.State.WithQueryParameters) {
            setQueryParams("global-search", "");
        }
        props.Dispatch(new TableMsg$1(1, [""]));
    })) : empty_1(), delay(() => append_1(map_2((tupledArg) => {
        let values_1, matchValue, paths, matchValue_2, testExpr, date, testExpr_1, endDate, startDate;
        const columnDefinition_1 = tupledArg[0];
        return new ActiveTableFilter(columnDefinition_1.Id, columnDefinition_1.Header, (values_1 = tupledArg[1], (matchValue = columnDefinition_1.Filter, isEmpty(values_1) ? t("table.active_filters.all_values") : ((matchValue === "none") ? join(", ", values_1) : ((matchValue === "select") ? joinValues(map_2(displayValue, values_1)) : ((matchValue === "categorySelect") ? joinValues(map_2(displayValue, values_1)) : ((matchValue === "locationSelect") ? ((paths = joinValues(map_2(displayValue, filter((value_1) => (value_1 !== "__exact_location__"), values_1))), contains("__exact_location__", values_1, {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        }) ? concat(paths, " - ", ...t("table.active_filters.without_sub_locations")) : paths)) : ((matchValue === "dateRange") ? ((matchValue_2 = tryParseDateRangeFilterValues(toArray(values_1)), (matchValue_2 != null) ? (((testExpr = matchValue_2, !equalsWith(equals_1, testExpr, defaultOf()) && (testExpr.length === 1))) ? ((date = item(0, matchValue_2), formatDate(date))) : (((testExpr_1 = matchValue_2, !equalsWith(equals_1, testExpr_1, defaultOf()) && (testExpr_1.length === 2))) ? ((endDate = item(1, matchValue_2), (startDate = item(0, matchValue_2), concat(formatDate(startDate), " - ", ...formatDate(endDate))))) : join(", ", values_1))) : join(", ", values_1))) : join(", ", values_1)))))))), () => {
            restoreDefaultColumnFilter(props.State, props.Dispatch, columnDefinition_1.Id);
        });
    }, activeColumnFilters(props.State)), delay(() => props.PageFilters))))));
    if (isEmpty(activeFilters)) {
        return defaultOf_1();
    }
    else {
        return reactElement("div", createObj(ofArray([["data-test-id", "active-filter-bar"], ["className", join(" ", ["flex", "flex-wrap", "items-center", "gap-x-3", "gap-y-2", "shrink-0", "px-6", "py-2.5", "border-t", "border-b", "border-border", "bg-[#F7FDFB]", "print:hidden"])], (elems_3 = toList(delay(() => {
            let elems_1, elems;
            return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "font-semibold", "text-primary-link", "mr-1"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems = [Filter_Text()], ["children", reactApi.Children.toArray(Array.from(elems))])]))), t("table.active_filters.title")], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append_1(map_2((activeFilter) => {
                const xs_2 = [createElement(ActiveFilterChip, {
                    Filter: activeFilter,
                })];
                return react.createElement(react.Fragment, {
                    key: activeFilter.FilterId,
                }, ...xs_2);
            }, activeFilters), delay(() => {
                let elems_2;
                return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["ml-auto"])], (elems_2 = [createElement(TextButton, {
                    ComponentState: "enabled",
                    Label: t("table.active_filters.reset_all"),
                    OnClick: () => {
                        props.Dispatch(new TableMsg$1(10, []));
                        iterate((pageFilter) => {
                            pageFilter.OnRemove();
                        }, props.PageFilters);
                    },
                    TestId: "active-filter-reset-button",
                    Variant: "blueButton",
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
            }))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
    }
}

export function TableElementsCounter(props) {
    let elems, matchValue, total_1, arg_1, arg_3;
    const i18n = useTranslation()[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-center", "h-10", "px-3.5", "text-sm", "rounded-lg", "bg-primary", "text-white"])], (elems = [reactElement("div", {
        "data-test-id": "table-elements-counter",
        children: (matchValue = props.TotalNumberOfElements, (matchValue != null) ? ((matchValue !== props.NumberOfElements) ? ((total_1 = (matchValue | 0), (arg_1 = {
            number: props.NumberOfElements,
            total: total_1,
        }, i18n.t("table.number_of_filtered_elements", arg_1)))) : ((arg_3 = {
            number: props.NumberOfElements,
        }, i18n.t("table.number_of_elements", arg_3)))) : ((arg_3 = {
            number: props.NumberOfElements,
        }, i18n.t("table.number_of_elements", arg_3)))),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function TableSettings(props) {
    let Title, Icon;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setResetTableConfigurationDialogIsOpen = patternInput_1[1];
    if ((props.CSVDownloadActivated ? true : props.ResetFilterEnabled) ? true : props.ResetConfigurationEnabled) {
        const xs = [createElement(ConfirmationDialog, (Title = t("table.confirm_reset_title"), {
            Description: t("table.confirm_reset_description"),
            IsOpen: patternInput_1[0],
            OnClose: () => {
                setResetTableConfigurationDialogIsOpen(false);
            },
            OnConfirm: () => {
                props.Dispatch(new TableMsg$1(14, []));
                setResetTableConfigurationDialogIsOpen(false);
            },
            Title: Title,
        })), createElement(DropdownButton, (Icon = Cog(), {
            Classes: empty(),
            ComponentState: props.CSVDownloadRunning ? "disabled" : "enabled",
            DisplayArrow: false,
            DisplayDivider: false,
            Elements: toList(delay(() => append_1(props.CSVDownloadActivated ? singleton_1({
                DisplayName: t("table.download_csv"),
                OnClick: () => {
                    props.Dispatch(new TableMsg$1(3, [true]));
                    downloadCsv(toArray_1(delay(() => {
                        let array;
                        return append_1(singleton_1(map((column_1) => FSharpMap__get_Item(props.ColumnDefinitionMap, column_1.id).Header, (array = props.Table.getAllLeafColumns(), array.filter((column) => column.getIsVisible())))), delay(() => map((row) => map((cell) => {
                            const matchValue = FSharpMap__get_Item(props.ColumnDefinitionMap, cell.column.id).AccessorFunction(row.original);
                            let matchResult, text, labels, inventoryType, label_2, date, dateTime;
                            switch (matchValue.tag) {
                                case 1: {
                                    matchResult = 0;
                                    text = matchValue.fields[0];
                                    break;
                                }
                                case 4: {
                                    matchResult = 1;
                                    labels = matchValue.fields[0];
                                    break;
                                }
                                case 5: {
                                    matchResult = 2;
                                    inventoryType = matchValue.fields[0];
                                    break;
                                }
                                case 2: {
                                    matchResult = 3;
                                    break;
                                }
                                case 3: {
                                    matchResult = 4;
                                    label_2 = matchValue.fields[0];
                                    break;
                                }
                                case 6: {
                                    matchResult = 5;
                                    break;
                                }
                                case 7: {
                                    matchResult = 6;
                                    break;
                                }
                                case 8: {
                                    if (matchValue.fields[0] == null) {
                                        matchResult = 8;
                                    }
                                    else {
                                        matchResult = 7;
                                        date = matchValue.fields[0];
                                    }
                                    break;
                                }
                                case 9: {
                                    if (matchValue.fields[0] == null) {
                                        matchResult = 10;
                                    }
                                    else {
                                        matchResult = 9;
                                        dateTime = matchValue.fields[0];
                                    }
                                    break;
                                }
                                default: {
                                    matchResult = 0;
                                    text = matchValue.fields[0];
                                }
                            }
                            switch (matchResult) {
                                case 0:
                                    return text;
                                case 1:
                                    if (length(labels) === 0) {
                                        return "";
                                    }
                                    else {
                                        return reduce((labels_1, label_1) => concat(labels_1, ", ", ...label_1), map_2((label) => label.Name, labels));
                                    }
                                case 2:
                                    return inventoryTypeLabel(t, inventoryType);
                                case 3:
                                    return "";
                                case 4:
                                    return label_2;
                                case 5:
                                    return "";
                                case 6:
                                    return "";
                                case 7:
                                    return toString(toLocalTime(date), "dd.MM.yyyy");
                                case 8:
                                    return "";
                                case 9:
                                    return toString(toLocalTime(dateTime), "dd.MM.yyyy HH:mm");
                                default:
                                    return "";
                            }
                        }, row.getVisibleCells()), props.Table.getRowModel().rows)));
                    })), "export.csv", () => {
                        props.Dispatch(new TableMsg$1(3, [false]));
                    });
                },
            }) : empty_1(), delay(() => append_1(props.ResetFilterEnabled ? singleton_1({
                DisplayName: t("table.reset_filter"),
                OnClick: () => {
                    props.Dispatch(new TableMsg$1(10, []));
                },
            }) : empty_1(), delay(() => (props.ResetConfigurationEnabled ? singleton_1({
                DisplayName: t("table.reset_configuration"),
                OnClick: () => {
                    setResetTableConfigurationDialogIsOpen(true);
                },
            }) : empty_1()))))))),
            Icon: unwrap(Icon),
            TestId: "download-csv-button",
        }))];
        return react.createElement(react.Fragment, {}, ...xs);
    }
    else {
        return defaultOf_1();
    }
}

